<style scoped lang="scss" type="text/scss">
    .overview-container {
        .status-cards {
            display: flex;
            flex-wrap: wrap;
            margin-left: -1rem;

            &.optional {
                margin-top: -1rem;
            }

            .status-card {
                margin: 1rem 0 0 1rem;
            }
        }
    }

    @media screen and (min-width: 75rem) and (max-width: 92rem) {
        .status-card {
            width: calc(14.28% - 1rem);
        }
    }

    @media screen and (min-width: 92rem) and (max-width: 100rem) {
        .status-card {
            width: calc(12.5% - 1rem);
        }
    }

    @media screen and (min-width: 100rem) {
        .status-card {
            width: calc(11.1% - 1rem);
        }
    }
</style>

<template>
    <div class="overview-container">
        <block-divider>必填信息</block-divider>

        <el-progress :stroke-width="8" :percentage="percentage"
                     :status="percentage === 100 ? 'success' : 'exception'">
        </el-progress>
        <div class="status-cards">
            <status-card v-for="(item, index) in required" :key="index"
                         class="status-card"
                         :info="item"
            >
            </status-card>
        </div>

        <block-divider>选填信息</block-divider>
        <div class="status-cards optional">
            <status-card v-for="(item, index) in optional" :key="index"
                         class="status-card"
                         :info="item"
            >
            </status-card>
        </div>
    </div>
</template>

<script>
    import BlockDivider from '../../../../../components/divider/block';
    import StatusTag from '../../../../../components/status-tag/index';
    import StatusCard from './status-card';

    export default {
        name: '',
        components: {
            BlockDivider,
            StatusTag,
            StatusCard
        },
        computed: {
            fillingStatus () {
                return this.$store.getters['player/fillingStatus'];
            }
        },
        watch: {
            fillingStatus: {
                immediate: true,
                handler (fillingStatus) {
                    const required = [];
                    const optional = [];
                    let completeCount = 0;
                    for (const index in fillingStatus) {
                        const current = fillingStatus[index];
                        if (current.required === false) {
                            optional.push(current);
                        } else {
                            required.push(current);
                            if (current.finished !== false) completeCount += 1;
                        }
                    }
                    this.required = required;
                    this.optional = optional;
                    if (required.length === 0) {
                        this.percentage = 0;
                    } else {
                        this.percentage = +(completeCount / required.length).toFixed(2) * 100;
                    }
                }
            }
        },
        data () {
            return {
                required: [],
                optional: [],
                percentage: 0
            };
        }
    };
</script>
